<template>

  <div>

    <default-rate-field-with-cdrs
      v-for="(_, n) in model.length"
      v-model="model[n]"
      :show-ids="showIds"
      :collapsible="collapsible"
      :collapsed="collapsed"
      :density="density"
      :disabled="disabled"
      :hide-details="hideDetails"
    />

  </div>

</template>

<script setup lang="ts">

/**
 * Control for editing multiple DefaultRates, along with their ChannelDefaultRates.
 */

import DefaultRateFieldWithCdrs from './DefaultRateFieldWithCdrs.vue'
import type { DefaultRateFieldWithCdrsState } from '../../../types/misc'

interface Props {
  showIds?: boolean
  disabled?: boolean
  collapsible?: boolean
  collapsed?: boolean
  density?: null | 'compact' | 'default' | 'comfortable'
  hideDetails?: boolean
}

withDefaults(defineProps<Props>(), {
  showIds: false,
  disabled: false,
  collapsible: true,
  collapsed: true,
  density: 'default',
  hideDetails: false,
})

const model = defineModel<DefaultRateFieldWithCdrsState[]>({required: true})

</script>
